import {
  Grid,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
} from "@material-ui/core";

import AutoCompleteField from "components/_refactor/fields/autocomplete";
import InputText from "components/_refactor/text/input";
import UploadFile from "components/_refactor/dropzone";

const ACCEPTED_FILE_TYPES =
  ".pdf,.doc,.docx,.ppt,.pptx,.txt,.jpg,.jpeg,.png,.gif,.webp";

const DOCUMENT_TYPES = [
  { value: "MANUAL", label: "Manual" },
  { value: "PROCEDIMENTO", label: "Procedimento" },
  { value: "OUTROS", label: "Outros" },
];

const MEDIA_TYPES = [
  { value: "MIDIA", label: "Mídia" },
  { value: "LINK", label: "Link" },
  { value: "POPUP", label: "Modal" },
];

export default function ViewData({
  type,
  setType,
  typeFile,
  setTypeFile,
  categories,
  categoriesLoading,
  selectedCategory,
  setSelectedCategory,
  title,
  setTitle,
  description,
  setDescription,
  link,
  setLink,
  setFilesToUpload,
  notify,
  setNotify,
  aceite,
  setAceite,
  disabled,
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <FormLabel required>Tipo de Documentação</FormLabel>
        <RadioGroup
          aria-label="opções de tipos de arquivos"
          required
          name="tipo"
          value={type}
          onChange={(e) => setType(e.target.value)}
          disabled={disabled}
          style={{ display: "flex", flexDirection: "row" }}
        >
          {DOCUMENT_TYPES.map((t) => (
            <FormControlLabel
              key={t.value}
              value={t.value}
              control={
                <Radio
                  size="small"
                  color="primary"
                  checked={type === t.value}
                />
              }
              label={t.label}
            />
          ))}
        </RadioGroup>
      </Grid>

      <Grid item xs={12} md={6}>
        <FormLabel required>Tipo de Arquivo</FormLabel>
        <RadioGroup
          aria-label="opções de tipos de arquivos"
          required
          name="midia"
          value={typeFile}
          onChange={(e) => setTypeFile(e.target.value)}
          disabled={disabled}
          style={{ display: "flex", flexDirection: "row" }}
        >
          {MEDIA_TYPES.map((t) => (
            <FormControlLabel
              key={t.value}
              value={t.value}
              control={
                <Radio
                  size="small"
                  color="primary"
                  checked={typeFile === t.value}
                />
              }
              label={t.label}
            />
          ))}
        </RadioGroup>
      </Grid>

      <Grid item xs={12} md={6}>
        <AutoCompleteField
          label="Categoria"
          required
          options={categories}
          optionLabelKey="Nome"
          optionIdKey="IdDocumentoAreaCategoria"
          value={selectedCategory}
          onChange={setSelectedCategory}
          disabled={disabled}
          loading={categoriesLoading}
          customTooltipText={(option) => option?.Descricao || ""}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <InputText
          label="Título"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          disabled={disabled}
          required
        />
      </Grid>

      <Grid item xs={12}>
        <InputText
          label="Descrição"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          disabled={disabled}
          required
          multiline
          rows={3}
        />
      </Grid>

      <Grid item xs={12}>
        {typeFile === "LINK" ? (
          <InputText
            label="Link"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            disabled={disabled}
            required
          />
        ) : (
          <UploadFile
            accept={ACCEPTED_FILE_TYPES}
            onChangeFiles={setFilesToUpload}
            disabled={disabled}
            message="Selecione um arquivo para anexar"
          />
        )}
      </Grid>

      <Grid item xs={6}>
        <FormControlLabel
          name="notify"
          control={
            <Checkbox
              color="primary"
              size="small"
              checked={notify}
              onChange={(e) => setNotify(e.target.checked)}
            />
          }
          label="Notificar usuário no acesso"
        />
      </Grid>
      <Grid item xs={6} hidden={!notify || typeFile !== "POPUP"}>
        <FormControlLabel
          name="aceite"
          control={
            <Checkbox
              color="primary"
              size="small"
              checked={aceite}
              onChange={(e) => setAceite(e.target.checked)}
            />
          }
          label="Solicitar aceite do usuário"
        />
      </Grid>
    </Grid>
  );
}
